import { PaymentMethodsProps } from "./PaymentMethods.types";
import * as PaymentMethodsSub from "./subcomponents";

/**
 * @description PaymentMethods component is used to display the payment methods available on the product page. The  product price with discount, credit card price with the installment fees and the credit card flags accepted..
 * @param data - The payment methods data that contains the price, discount and installments
 * @example
 * <PaymentMethods data={data} />
 * @see https://ferreiracosta.atlassian.net/browse/ECOMDGT-13084
 */
export const PaymentMethods = ({ data }: Pick<PaymentMethodsProps, "data">) => {
  const { discount, price, installments, priceWithDiscount } = data;

  return (
    <PaymentMethodsSub.Root>
      <PaymentMethodsSub.PixPayment
        discount={discount}
        price={priceWithDiscount || price}
      />
      <PaymentMethodsSub.HorizontalDivider />
      <PaymentMethodsSub.CreditCardContainer>
        <PaymentMethodsSub.SubTitle>
          Cartão de Crédito
        </PaymentMethodsSub.SubTitle>
        <PaymentMethodsSub.Installments data={installments} />
        <PaymentMethodsSub.CardsFlags />
      </PaymentMethodsSub.CreditCardContainer>
    </PaymentMethodsSub.Root>
  );
};
